import React from "react";
import MobilePage from "../../../Components/MobilePage";
import { useHistory } from "react-router";
import AppBar from "../../Components/AppBar";
import FrontPage from "../../../Components/FrontPage/FrontPage";
import useRoutes from "../../../hooks/useRoutes";
import { useAuth } from "../../../providers/AuthProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";
import { usePriceList } from "@/react/Webshop/providers/PriceListProvider";

const MobileFrontPage = () => {
  const history = useHistory();
  const routes = useRoutes();
  const { update } = usePictureSets();
  const { referrer, setReferrer } = useAuth();
  const { updatePriceList } = usePriceList();

  const navigateAfterLogin = (loginResult) => {
    if (loginResult?.redirect === "/sc") {
      document.location.href = loginResult.redirect;
      return;
    }

    if (referrer) {
      history.push(referrer);
      setReferrer(null);
      return;
    }

    history.push(routes["products.packages"].path);
  };

  const handleLoginSuccess = (loginResult) => {
    navigateAfterLogin(loginResult);
  };

  const handleLoginSuccessNewCode = (loginResult) => {
    if (loginResult?.redirect === "/sc") {
      document.location.href = loginResult.redirect;
      return;
    }

    // We need to reload the price list in case of changes:
    updatePriceList();

    // Load the current user:
    update().then(() => {
      history.push(routes.newpictureset.path);
    });
  };

  return (
    <MobilePage fullHeight>
      <AppBar disableBottomMargin={true} />
      <FrontPage
        handleLoginSuccess={handleLoginSuccess}
        handleLoginSuccessNewCode={handleLoginSuccessNewCode}
      />
    </MobilePage>
  );
};

export default MobileFrontPage;
